import { useTranslations } from 'next-intl';

import QuantaIcon from '@/components/QuantaIcon';

import DisplayCard from './DisplayCard';

interface PointsRankingCardProps {
  totalPoints: number;
  ranking: number | null;
  width?: number;
}

const PointsRankingCard: React.FC<PointsRankingCardProps> = ({ totalPoints, ranking, width }: PointsRankingCardProps) => {
  const t = useTranslations('quanta.stats');

  return (
    <div className="flex flex-1 xl:flex-none shrink-0">
      <div className="flex-1 z-10">
        <DisplayCard
          title={t('quanta')}
          value={totalPoints}
          width={width}
          icon={<QuantaIcon alt="Quanta" size={28} className="size-7" />}
        />
      </div>
      <div className="flex-1 -ml-10">
        <DisplayCard title={t('ranking')} value={ranking} isBorder={true} width={width} />
      </div>
    </div>
  );
};

export default PointsRankingCard;
